import Bank from ".";
import authRoles from "../../utils/auth.roles";
const BankRoutes = {
  auth: authRoles.user,
  kyc: false,
  bank: false,
  routes: [
    {
      path: "/bank",
      component: Bank,
      exact: true,
    },
  ],
};
export default BankRoutes;
